export default "__VITE_ASSET__BZq6Opze__"